export function formatDate(datetime: string) {
    if (datetime === undefined) {
        return datetime;
    }
    return datetime.split('.')[0].replace('T', ' ');
};

export function formatPlaytime(playtime: number) {
    return `${playtime.toFixed(0)} min`;
}